import React from 'react';
import { SxStyle } from '../../../../../types';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Loading from '../../../../loading';
import Box from '@mui/material/Box';

const styles: SxStyle = {
  loading: {
    height: '150px',
  },
  header: (theme) => ({
    padding: '16px',
    height: '72px',
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider,
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.divider,
  }),
  content: {
    minWidth: 400,
  },
};

interface Props {
  title: string;
  buttonElement: React.ReactElement;
  loading?: boolean;
  children: React.ReactElement;
}

const PlayerTabContent = ({ title, buttonElement, loading, children }: Props) => {
  return (
    <>
      <Grid container direction="row" alignItems="center" sx={styles.header}>
        <Grid xs item>
          <Typography variant="h6">{title}</Typography>
        </Grid>
        <Grid item>{buttonElement}</Grid>
      </Grid>
      {loading ? (
        <Box sx={styles.loading}>
          <Loading />
        </Box>
      ) : (
        <TableContainer>
          <Table sx={styles.content}>{children}</Table>
        </TableContainer>
      )}
    </>
  );
};

export default PlayerTabContent;
